import * as type from '../types';

const initialState = {
  list: [],
  loading: false,
  error: false,
};

export default function stations(state = initialState, action) {
  switch (action.type) {
    case type.STATION_SEARCH_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.STATION_SEARCH_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.STATION_SEARCH_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.GET_STATIONS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_STATIONS_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_STATIONS_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.SET_STATIONS:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
}
